"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importDefault(require("react"));
var Tooltip = function (_a) {
    var children = _a.children, text = _a.text, className = _a.className, position = _a.position;
    if (!text)
        return react_1.default.createElement(react_1.default.Fragment, null, "children");
    var _b = position === "left"
        ? ["Tooltip-left", "TooltipText-left"]
        : ["Tooltip", "TooltipText"], tooltipClass = _b[0], tooltipTextClass = _b[1];
    return (react_1.default.createElement("div", { className: "".concat(tooltipClass, " relative inline-block cursor- ").concat(className) },
        children,
        react_1.default.createElement("span", { className: "".concat(tooltipTextClass, " absolute border border-gray p-1 rounded-lg invisible\nbg-grey-darkest text-grey-lighter z-10 text-center") }, text)));
};
exports.Tooltip = Tooltip;
